import { Component, ViewChild } from '@angular/core';
import { App, Content, IonicPage, LoadingController, NavController, NavParams, ToastController } from 'ionic-angular';
import { Provincia } from '../../models/provincia.model';
import { ListaCategorias } from '../lista-categorias/lista-categorias';
import { Pueblo } from '../../models/pueblo.model';
import { Consultas } from '../../providers/consultas';
import { VariablesGlobales } from '../../providers/variables-globales';
import { PuebloTabsPage } from '../pueblo-tabs/pueblo-tabs';
import { MapaProvinciasPage } from '../mapa-provincias/mapa-provincias';
import { ListaPueblosPage } from '../lista-pueblos/lista-pueblos';

/**
 * Generated class for the ListaProvinciasPage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */
@Component({
  selector: 'page-lista-provincias',
  templateUrl: 'lista-provincias.html',
  providers: [ Consultas ]
})
export class ListaProvinciasPage {

  @ViewChild(Content) content: Content;

  public provincias: Array<Provincia>;
  public loader: any;
  public pueblo: Pueblo;
  public tamañoElementosAbiertosAnterior: number;


  constructor(public navCtrl: NavController,
    public navParams: NavParams,
    public consultas: Consultas,
    public loadingCtrl: LoadingController,
    public global: VariablesGlobales,
    private app: App,
    private toastCtrl: ToastController) {
    this.pueblo = this.navParams.data as Pueblo;
    this.provincias = new Array<Provincia>();

    console.log('constructor');
  }

  goToListaPueblosMenu(idProvincia){
    this.navCtrl.push(ListaPueblosPage,{idProvincia});
  }

  vistaMapa(){
    this.navCtrl.setRoot(MapaProvinciasPage,);
  }

  ngOnInit() {
    let provincias = new Array<Provincia>();
    this.loader = this.loadingCtrl.create();
    //Muestro el cargador mientras se cargan los productos
    this.loader.present().then(() => {
      this.consultas.getProvinciasComunidad('').subscribe(
        data => {
          console.log(data)
         this.provincias = data;
        },
        error => {
          console.log(error);
          this.loader.dismiss();
        },
        () => {
          this.loader.dismiss();
        }
      );
    });
  }
  ionViewDidLoad() {

  }
}



// WEBPACK FOOTER //
// ./src/pages/lista-provincias/lista-provincias.ts